import { setTheme } from '@fluentui/web-components';
import { webDarkTheme, webLightTheme } from '@fluentui/tokens';

import '@fluentui/web-components/accordion.js'
import '@fluentui/web-components/accordion-item.js'
import '@fluentui/web-components/button.js';
import '@fluentui/web-components/dialog.js'
import '@fluentui/web-components/dialog-body.js'
import '@fluentui/web-components/dropdown.js'
import '@fluentui/web-components/link.js'
import '@fluentui/web-components/listbox.js'
import '@fluentui/web-components/message-bar.js'
import '@fluentui/web-components/option.js'
import '@fluentui/web-components/text.js';
import '@fluentui/web-components/tooltip.js'

const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");

function applyTheme(e) {
    if (e.matches) {
        setTheme(webDarkTheme);
    } else {
        setTheme(webLightTheme);
    }
}

// Initial theme setting
applyTheme(darkThemeMq);

// Listen for changes in the color scheme
darkThemeMq.addEventListener('change', applyTheme);
